import React, { useEffect } from "react";
import "./campaign.css";
import campaign from "../../img/laptop.svg";
import CheckmakerContainer from "../CheckmakerContainer/CheckmakerContainer";
import Aos from "aos";

import "aos/dist/aos.css";
const Campaign = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div className="campaign" id="campaign-section">
      <div className="campaign-section container" data-aos="fade-right">
        <CheckmakerContainer
          header="Our Campaign"
          heading="Empowering the Underprivileged"
          text="Mehfooz Mustaqbil Foundation aims to help underprivileged students get educational opportunities and help them equip themselves with the most in-demand technical education to become financially stable"
          cm1="Empowering the underprivileged with educational opportunities"
          cm2="Offering neccessary tools and resource for self-sufficieny"
          cm3="Fostering financial independence through technical training programs"
          cm4="Creating oppurtunities for underpriviliged individuals to thrive in the job market"
        ></CheckmakerContainer>

        <div className="campaign-left-section">
          <img src={campaign} alt="campaign" fetchpriority="high"></img>
        </div>
      </div>
    </div>
  );
};

export default Campaign;
